import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "components/Button";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import styled from "styled-components";
const ModalButtonWrapper = styled.div``;

const GalleryButton = (props) => {
	const [open, setOpen] = useState(false);

	const { label, slides } = props;

	return (
		<ModalButtonWrapper>
			<Button onClick={() => setOpen(true)}>{label}</Button>
			<Lightbox
				open={open}
				close={() => setOpen(false)}
				slides={slides}
			/>
		</ModalButtonWrapper>
	);
};

GalleryButton.propTypes = {
	label: PropTypes.string.isRequired,
	slides: PropTypes.array.isRequired,
};

export default GalleryButton;
